import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import type { FormData } from "types/index";

// import { EmojiPicker } from "./EmojiPicker";

import IntlTelInput, { CountryData } from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";

interface MessageFormProps {
    onGenerateLink: (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    handleFormInputChange: (userInput: Partial<FormData>) => void;
    data: FormData;
    isLoading: boolean;
    validateForm: () => boolean;
}
/**
 * @deprecated Don't use this form.
 */
const Qrform: React.FC<MessageFormProps> = (props) => {
    const {
        onGenerateLink,
        handleFormInputChange,

        data: { phn_no, message },
        isLoading,
    } = props;

    const verifyPhoneNumber = (text: string) => {
        let isPhnNo = false;
        if (text.length > 15) return false;
        if (text.length === 0) return true;
        for (let i = 0; i < text.length; i++) {
            const ascii = text.charCodeAt(i);
            if ((ascii >= 48 && ascii <= 57) || (ascii === 43 && i === 0)) {
                isPhnNo = true;
            } else {
                return false;
            }
        }
        return isPhnNo;
    };
    return (
        <div className=" mx-auto pb-16 container" style={{ width: "100%", maxWidth: "1000px" }}>
            <form onSubmit={onGenerateLink} id="gb_LinkGenerator_form">
                <div>
                    <h2 className="text-center pt-20 pb-4">Create Your Free WhatsApp QR Code Here:</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 mb-5 ">
                    <div className="mb-3 md:mb-0 md:mr-3 ">
                        <p className="font-medium text-2xl gray-800">Your WhatsApp Number</p>
                        <p className="text-lg gray-600">Select your country and your WhatsApp number</p>
                    </div>
                    <div className="">
                        <IntlTelInput
                            containerClassName="intl-tel-input w-full leading-10"
                            inputClassName="bg-white w-full rounded-md h-12 focus:outline-none focus:ring-2 focus:ring-crayola-blue focus:border-transparent"
                            onSelectFlag={(e: string, countryData: CountryData, fullNumber: string, isValid: boolean) => {
                                handleFormInputChange({
                                    country_code: countryData.dialCode,
                                    isValidPhnNo: isValid,
                                    //  'phn_no':'+' + countryData.dialCode
                                });
                            }}
                            onPhoneNumberChange={(isValid: boolean, value: string) => {
                                if (verifyPhoneNumber(value)) {
                                    handleFormInputChange({ phn_no: value, isValidPhnNo: isValid });
                                }
                            }}
                            placeholder=""
                            defaultCountry="in"
                            value={phn_no}
                            data-cy="wa-link-phnno"
                        />
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 ">
                    <div className="mb-3 md:mb-0 md:mr-3">
                        <p className="font-medium text-2xl gray-800">Welcome Message (Optional)</p>
                        <p className="text-lg gray-600">This text will be automatically included when a user clicks on your chat link, making it easier to start a conversation.</p>
                    </div>
                    <div className="">
                        <textarea
                            name="message"
                            placeholder=""
                            rows={3}
                            className="bg-white rounded-md w-full border-slate-300 p-2.5 resize-none focus:outline-none focus:ring-2 focus:ring-crayola-blue focus:border-transparent"
                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => {
                                handleFormInputChange({ message: e.target.value });
                            }}
                            value={message}
                            data-cy="wa-link-message"
                        />{" "}
                    </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 text-end mt-5">
                    <div></div>
                    <button
                        data-cy="generate-mylink"
                        className={`hover:bg-blue-600 self-center ${isLoading ? "bg-blue-600" : "bg-blue-500"} border-slate-300 w-full rounded-md font-semibold p-4 text-white
                        focus:outline-none focus:ring-2 focus:ring-green-border focus:border-transparent`}
                        onClick={onGenerateLink}
                        type="submit"
                    >
                        {isLoading ? <ClipLoader color={"#ffffff"} loading={true} size={20} /> : "Generate WhatsApp QR Code"}
                    </button>
                </div>
            </form>
        </div>
    );
};
export default Qrform;
